<template>
  <div id="app" v-if="menuDataReady">
    <div class="appWrap fill-parent">
      <div class="right-container">
        <div class="top-content">
          <navigation-top @on-select-account="onSelectAccount" />
        </div>
        <div class="main-content">
          <div class="body-view">
            <div class="right-view">
              <div
                v-for="(item, index) in SsoRoutes"
                :class="`list-row ${!item.isDisabled ? 'list-row-hover' : ''}`"
                :key="index"
                @mouseenter="changeWho(item)"
                @mouseleave="changeout(item)"
              >
                <div class="left-content">
                  <img class="img-src" :src="item.meta.icon" alt />
                </div>
                <div class="right-content">
                  <div class="title-name" v-if="item.isShowwho">
                    <span>{{ item.meta.title.split("-")[0] }}</span>
                  </div>
                  <!-- <div class="describe-content">
                      <span>{{item.describe}}</span>
                  </div> -->
                  <div class="btn-view" v-else>
                    <div
                      :class="`enter-system ${
                        item.isDisabled ? 'isDisabled' : ''
                      }`"
                      @click="linkSso(item)"
                    >
                      <!-- <span class="btn-span">{{item.type != 8?'进入系统':'农机平台'}}</span> -->
                      <span class="btn-span">{{ "进入系统" }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationTop from "@/components/navigation/top.vue";
import ApiData from "./api-main";
import CommonData from "@/services/model/common-data";
import pathConfig from "@/config/pathConfig";

export default {
  components: {
    NavigationTop,
  },
  data() {
    return {
      commonData: new CommonData(this),
      apiData: new ApiData(this),
      menuDataReady: false,
      isFirstLoad: true,
      isShowwho: true,
      model: {
        username: "",
        password: null,
      },
      SsoRoutes: [],
      systemArr: [
        // {
        //   name: "大数据平台",
        //   type: 3,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/8.png"),
        //   path: pathConfig.bigData,
        //   isShowwho: true,
        // },
        // {
        //   name: "物联网云平台",
        //   type: 3,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/1.png"),
        //   path: pathConfig.Cloud,
        //   isShowwho: true,
        // },
        // {
        //   name: "业务管理",
        //   type: 8,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/12.png"),
        //   path: pathConfig.system,
        //   isShowwho: true,
        // },
        // {
        //   name: "ERP管理平台",
        //   type: 3,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/11.png"),
        //   path: pathConfig.erp,
        //   isShowwho: true,
        // },
        // {
        //   name: "溯源平台",
        //   type: 6,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/9.png"),
        //   path: pathConfig.source,
        //   isShowwho: true,
        // },
        // {
        //   name: "农资管理",
        //   type: 6,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/10.png"),
        //   path: pathConfig.nongzi,
        //   isShowwho: true,
        // },
        // {
        //   name: "农机管理",
        //   type: 1,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/6.png"),
        //   path: pathConfig.nongji,
        //   isShowwho: true,
        // },
        // {
        //   name: "权限管理",
        //   type: 5,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/mainimage/5.png"),
        //   path: pathConfig.febs,
        //   isShowwho: true,
        // },
      ],
    };
  },
  computed: {},
  created() {
    this.checkToken();
  },
  mounted() {
    let that = this;
    // window.loading(false);
    // this.getUserInfo();
  },
  methods: {
    changeWho(item) {
      item.isShowwho = false;
    },
    changeout(item) {
      item.isShowwho = true;
    },
    getUserInfo() {
      if (
        window.location.href.indexOf("?") > 0 &&
        window.location.href.indexOf("token") > 0
      ) {
        console.log("###########", window.location.href.split("="));
        let token = window.location.href.split("=")[1];
        this.$localStorage.set("access_token", token);
      }
      this.apiData.getUserInfo().then((data) => {
        this.$localStorage.set("account", data);
        this.getSystemMenu();
      });
    },
    getSystemMenu() {
      this.apiData
        .getSystemMenu(this.$localStorage.get("account").username)
        .then((res) => {
          let rortes_sso = [];
          let sso = res.routes.filter((item) => item.name == "SSO导航");
          if (sso.length != 0) {
            if (sso[0].children) {
              rortes_sso = sso[0].children;
              rortes_sso.forEach((item) => {
                item.isShowwho = true;
              });
            } else {
              rortes_sso = [];
            }
          } else {
            rortes_sso = [];
          }
          console.log("rortes_sso", rortes_sso);
          this.SsoRoutes = rortes_sso;
        });
    },
    checkToken() {
      const token = this.$localStorage.get("access_token");
      if (!token) {
        window.location.href = window.prePath + "/index.html?web#/login";
      } else {
        let userInfo = this.$localStorage.get("account");
        if (userInfo.roleId) {
          let roleList = userInfo.roleId.split(",");
          let isadmin = roleList.some((item) => item == "1");
          let isYW = roleList.some((item) => item == "2");
          let isCrop = roleList.some((item) => item == "3");
          //admin
          if (isadmin) {
            window.location.href = "/febs/index.html";
            return;
          }
          //运维角色(需用精准种植设备导入)
          // if (isYW) {
          //   window.location.href = "/febs/index.html";
          //   return;
          // }
          //作物管理员直接跳转到作物模板管理。其他模快不需查看
          if (isCrop) {
            window.location.href = "/cloud/main.html";
            return;
          }
          window.location.href = "/cloud/main.html";
        } else {
          window.location.href = "/cloud/main.html";
        }
      }
    },
    onSelectAccount() {
      window.location.reload();
    },
    linkSso(data) {
      if (data.component !== "2") {
        window.location.href = data.path;
      } else {
        window.open(data.path);
      }
    },
    clickLogout() {
      localStorage.clear();
      window.location.href = "/index.html?web#/login";
    },
  },

  watch: {},
};
</script>

<style lang="scss">
@import "./../../components-base/element-rewrite/_index.scss";
</style>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
/*滚动条样式修改*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d0d0d0;
}
.appWrap {
  height: 100%;
  display: flex;
  user-select: none;
  // background: url("~@/assets/images/pagesbj.png") no-repeat;
  // background-size: 100% 100%;
  background-color: #f5f5f5;
  .left-container {
    width: 60px;
    height: 100%;
  }
  .right-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .top-content {
      height: 60px;
      // background: url("~@/assets/images/headerbj.png") no-repeat;
      // background-size: 100% 100%;
      background-color: #283343;
      // box-shadow: 0 4px 0 rgba(0, 0, 0, 0.3);
    }
    .main-content {
      width: 100%;
      height: calc(100% - 60px);
      background: url("../../assets/images/bgConntent.png") no-repeat;
      background-size: 100% 100%;
      overflow: hidden;

      .body-view {
        box-sizing: border-box;
        // padding: 28px 60px 0 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
        overflow: auto;
        .left-view {
          width: 360px;
          margin-right: 40px;
          height: 540px;
          padding: 32px 34px;
          background-color: rgba(51, 51, 51, 0.5);
          border-radius: 0 0 4px 4px;
          overflow: hidden;
          .user-msg {
            display: flex;
            align-items: center;
            .msg-left {
              width: 82px;
              height: 82px;
              border: 4px solid #878787;
              border-radius: 40px;
              overflow: hidden;
              .user-avatar {
                width: 74px;
                height: 74px;
              }
            }
            .msg-right {
              flex: 1;
              margin-left: 10px;
              .user-name {
                color: #ffffff;
                font-size: 17px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .edit-icon {
                  cursor: pointer;
                  color: #999;
                }
              }
              .user-level {
                margin-top: 8px;
                font-size: 15px;
                color: #02aa9f;
              }
            }
          }
          .user-msg-list {
            margin-top: 30px;
            .msg-list {
              height: 55px;
              border-bottom: 2px solid #3a3a3a;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .edit-icon {
                cursor: pointer;
                color: #999;
                font-size: 17px;
              }
              .inputbox {
                position: relative;
                display: inline-flex;
                justify-content: space-between;
                line-height: 30px;
                height: 30px;
                text-align: center;
                &::before {
                  position: absolute;
                  color: #c6c6c6;
                  font-size: 20px;
                  left: 0px;
                  top: 0px;
                  box-sizing: border-box;
                  width: 30px;
                  height: 30px;
                  line-height: 30px;
                }
                input {
                  color: #666666;
                  background: transparent;
                  background-color: transparent;
                  outline: none;
                  line-height: 30px;
                  font-size: 14px;
                  border-radius: 4px;
                  vertical-align: middle;
                  border: 0;
                }
                input[type="text"],
                input[type="password"] {
                  padding-left: 40px;
                  letter-spacing: 1px;
                  box-sizing: border-box;
                  outline: none;
                }
              }
            }
          }
          .btn-view {
            width: 100%;
            .list-btn {
              width: 100%;
            }
            .inputbox {
              position: relative;
              display: inline-flex;
              width: 100%;
              justify-content: space-between;
              line-height: 30px;
              height: 30px;
              text-align: center;
              .full {
                width: 100%;
              }
            }
            input {
              color: #e3e3e3;
              background: #606060;
              background-color: #606060;
              outline: none;
              line-height: 30px;
              font-size: 14px;
              border-radius: 4px;
              vertical-align: middle;
              border: 0;
            }
            input[type="button"] {
              cursor: pointer;
              border: 1px solid #606060;
            }
            input[type="button"].signout {
              background-color: #00b2a6;
              border: 1px solid #00b2a6;
            }
          }
        }
        .top-view {
          width: 100%;
          height: 97px;
          color: #333;
          font-size: 32px;
          text-align: center;
          line-height: 97px;
        }
        .right-view {
          width: 66%;
          // background-color: rgba(51, 51, 51, 0.5);
          // padding: 25px 40px 0 40px;
          // min-height: 730px;
          // overflow: hidden;
          // overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          // justify-content: center;
          align-content: center;
          margin-top: 15px;
          .list-row {
            // margin-bottom: 26px;
            width: 392px;
            height: 262px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: rgba(47, 47, 47, 0.5);
            margin: 0 12px 20px 12px;
            border: 1px solid rgba(100, 100, 100, 0.5);
            transition: box-shadow 0.4s, transform 0.4s;
            border-radius: 20px;
            color: #ffffff;
            .left-content {
              width: 175px;
              height: 161px;
              .img-src {
                width: 100%;
                height: 100%;
              }
            }
            .right-content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              // padding-bottom: 10px;
              margin-top: 20px;
              .title-name {
                font-size: 18px;
              }
              .describe-content {
                font-size: 12px;

                line-height: 17px;
              }
              .enter-system {
                margin-top: 19px;
                width: 135px;
                height: 41px;
                // line-height: 41px;
                padding: 8px 0;
                background: #3377ff;
                text-align: center;
                // border: 1px solid #707070;
                border-radius: 62px;
                cursor: pointer;
                .lockBg {
                  width: 30px;
                  height: 30px;
                }
              }
              .isDisabled {
                background: #c6c7c7;
                border: 1px solid #c6c7c7;
                cursor: not-allowed;
              }
              .btn-view {
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }
          .list-row-hover:hover {
            transform: translateY(-2%);
            background: conic-gradient(
                from 43.24deg at 50% 50%,
                rgba(141, 158, 209, 0) 0deg,
                rgba(54, 103, 255, 0.4) 181.87deg,
                rgba(185, 193, 218, 0) 360deg
              ),
              rgba(25, 65, 125, 0.2);
            box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.53);
            border: 1px solid #9db5ff;
            .enter-system {
              background: #3377ff;
              // border: 1px solid #283343;
              color: #ffffff;
            }
          }
        }
        .login-footer {
          height: 67px;
          margin-top: 24px;
          margin-bottom: 35px;
          font-size: 12px;
          color: #8c8c8c;
          width: 100%;
          text-align: center;
          .p-height {
            margin: 0;
            line-height: 17px;
          }
          .marginTop {
            // margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>